// Background subsection form field enum
export enum BackgroundFormField {
  BACKGROUND_PRIMARY_DIAGNOSIS = 'medicalBackground/background/primaryDiagnosis',
  BACKGROUND_OTHER_DIAGNOSIS = 'medicalBackground/background/otherDiagnosis',
  BACKGROUND_EQUIPMENT = 'medicalBackground/background/equipment',
  BACKGROUND_EQUIPMENT_OTHER = 'medicalBackground/background/equipmentOther',
  BACKGROUND_DME_PROVIDER = 'medicalBackground/background/dmeProvider',
  BACKGROUND_ALLERGIES = 'medicalBackground/background/allergies',
  BACKGROUND_ALLERGIES_NOTES = 'medicalBackground/background/allergiesNotes',
  BACKGROUND_WAIVERS = 'medicalBackground/background/waivers',
  BACKGROUND_ADDITIONAL_SERVICES = 'medicalBackground/background/additionalServices',
  BACKGROUND_PROGNOSIS = 'medicalBackground/background/prognosis',
  BACKGROUND_DNR = 'medicalBackground/background/dnr',
  BACKGROUND_ADVANCE_DIRECTIVES = 'medicalBackground/background/advanceDirectives',
  BACKGROUND_ADVANCE_DIRECTIVES_NOTES = 'medicalBackground/background/advanceDirectivesNotes'
}
